import { observer } from 'mobx-react';

import Icon from '@/common/components/Icon/Icon';
import { useForwardShareStore } from '@/forwarding/components/ForwardModal/ForwardShareStore';
import { ShareActionType } from '@/forwarding/constants/ShareActionType';
import { getShareActionIcon } from '@/forwarding/utils/getShareActionIcon';
import { getShareActionTitle } from '@/forwarding/utils/getShareActionTitle';

import styles from './RecentShareActionItem.module.css';

export interface RecentShareActionItemProps {
  action: ShareActionType;
  ariaLabel?: string;
  onSelect?: () => void;
}

function RecentShareActionItem(props: RecentShareActionItemProps) {
  const { action, ariaLabel, onSelect } = props;
  const { hasMultipleUrls } = useForwardShareStore();

  return (
    <div className={styles.recentShareActionItem} aria-label={ariaLabel} onClick={onSelect}>
      <div className={styles.iconContainer}>
        <Icon name={getShareActionIcon(action)} className={styles.icon} />
      </div>

      {getShareActionTitle(action, hasMultipleUrls)}
    </div>
  );
}

export default observer(RecentShareActionItem);
